function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { reduceFee } from '../../Products/Charts/FundScatterComparison/utils';
import { axisDimensions } from './data';
export var reducePerformancePeriod = function reducePerformancePeriod(stats, periodCode, type) {
  return stats.find(function (stat) {
    return stat.period === periodCode && stat.type === type;
  });
};
var reduceStatPeriod = function reduceStatPeriod(stats, statType, periodCode) {
  var data = stats.hasOwnProperty(statType) ? stats[statType] : null;
  if (data) {
    return data.find(function (stat) {
      return stat.period === periodCode;
    });
  }
  return null;
};
export var getInitialAxis = function getInitialAxis(contextFunds) {
  var axisPreference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['r36', 'r12'];
  var defaultAxis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'r12';
  if (!contextFunds.length) {
    return axisDimensions.find(function (item) {
      return item.id === defaultAxis;
    });
  }
  var fund = contextFunds[0];
  var _loop = function _loop() {
    var code = axisPreference[i];
    var itAxis = axisDimensions.find(function (item) {
      return item.id === code;
    });
    if (itAxis) {
      var _itAxis$value = itAxis.value,
        dimension = _itAxis$value.dimension,
        stat = _itAxis$value.stat,
        period = _itAxis$value.period;
      if (dimension === 'fee') {
        var value = reduceFee(fund, itAxis.value.fee);
        if (value) {
          return {
            v: itAxis
          };
        }
      }
      if (dimension === 'performance') {
        var performance = reducePerformancePeriod(fund.stats.performance.periods, itAxis.value.period, itAxis.value.type);
        if (performance) {
          return {
            v: itAxis
          };
        }
      }
      if (dimension === 'stat') {
        var _value = reduceStatPeriod(fund.stats, stat, period);
        if (_value) {
          return {
            v: itAxis
          };
        }
      }
    }
  };
  for (var i = 0; i < axisPreference.length; i++) {
    var _ret = _loop();
    if (_typeof(_ret) === "object") return _ret.v;
  }
  return axisDimensions.find(function (item) {
    return item.id === defaultAxis;
  });
};